import { render, staticRenderFns } from "./SKUUpload.vue?vue&type=template&id=38d18ae5&scoped=true"
import script from "./SKUUpload.vue?vue&type=script&lang=js"
export * from "./SKUUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d18ae5",
  null
  
)

export default component.exports